import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../common-service';
import { GenderResponse } from '../../responses/medical-record/gender.response';

@Injectable({
    providedIn: 'root'
})

export class ClientLookupService extends CommonService {

    constructor(private router: Router, private httpClient: HttpClient,) {
        super();
    }

    public getGender(): Observable<GenderResponse> {

        return this.httpClient.get<GenderResponse>(environment.urlApiMedicalRecord + `ClientLookup`)
            .pipe(
                catchError(this.handleError)
            )
    }
}